import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import {SearchRequest, SearchResponse, DeleteRequest, DeleteResponse, UserResponse, PersistUserRequest,
    PersistUserResponse,
    GetRolesForUserResponse,
    GetRolesForUserRequest,
    PersistRoleUsersRequest,
    PersistRoleUsersResponse} from "../../models/manage/user.models";

@autoinject()
export class ManageUsersClientService {

    constructor(private requestClient: RequestClientService) {
    }

    getAllUsers(request: SearchRequest): Promise<SearchResponse> {
        return this.requestClient.get<SearchResponse>("user", request);
    }

    delete(request: DeleteRequest): Promise<DeleteResponse> {
        return this.requestClient.post<DeleteResponse>("user/delete", {}, request);
    }

    getUser(userId: number): Promise<UserResponse> {
        return this.requestClient.get<UserResponse>("user/" + userId, {});
    }

    save(request: PersistUserRequest): Promise<PersistUserResponse> {
        return this.requestClient.postFormData<PersistUserResponse>("user/save", request);
    }
    
    persistRoleUsers(request: PersistRoleUsersRequest): Promise<PersistRoleUsersResponse> {
        return this.requestClient.post<PersistRoleUsersResponse>("user/persistRoleUsers", {}, request);
    }

    getRolesForUser(userId: number): Promise<GetRolesForUserResponse> {
        const request: GetRolesForUserRequest = {
            userId: userId
        };

        return this.requestClient.get<GetRolesForUserResponse>("user/getRolesForUser", request);
    }
}
